<template>
    <b-modal
        ref="sectionConfigModal"
        centered
        title="Section Configuration"
        size="lg"
    >
        <div v-if="section">
            <div
                v-if="!autonomous"
                class="form-group"
            >
                <label>Section Client Key</label>
                <input type="text" class="form-control" v-model="section.clientKey">
            </div>
            <div
                v-if="!autonomous"
                class="form-group"
            >
                <label>Show If</label>
                <input type="text" class="form-control" v-model="section.vif">
            </div>


            <div class="form-group">
                <label>Label Position</label>
                <select class="form-control" v-model="section.labelPosition">
                    <option value="left">Horizontal</option>
                    <option value="top">Vertical</option>
                </select>
            </div>
            <div
                v-if="!autonomous"
                class="form-group"
            >
                <label><input type="checkbox" v-model="section.isDynamic"> Is Dynamic Form?</label>
            </div>

            <div
                class="row"
                v-if="section.isDynamic && !autonomous"
            >
                <b-form-group>
                    <div class="col-md-6">
                        <label>Min instance</label>
                        <input type="number"
                                min="0"
                                class="form-control"
                                data-toggle='tooltip'
                                title="Minimum instance for dynamic section"
                                v-model="section.minInstance">
                    </div>
                    <div class="col-md-6">
                        <label>Max instance</label>
                        <input type="number"
                                min="0"
                                class="form-control"
                                data-toggle='tooltip'
                                title="Maximum instance for dynamic section. 0 for unlimited."
                                v-model="section.maxInstance">
                    </div>
                </b-form-group>
            </div>
        </div>

        <div slot="modal-footer">
            <button type="button" class="btn btn-default" @click="save">Save</button>
            <button type="button" class="btn btn-default" @click="closeModal">Close</button>
        </div>
    </b-modal>
</template>

<script>
    export default {
        name: "SectionConfigModal",
        props:['updateSectionInfo'],
        data: () => ({
            index: null,
            section: null,
            autonomous: false
        }),
        methods: {
            openModal(sectionInfo, index) {
                this.section = _.cloneDeep(sectionInfo);
                this.index = _.clone(index);
                if (this.$refs.sectionConfigModal) this.$refs.sectionConfigModal.show()
            },
            closeModal() {
                if (this.$refs.sectionConfigModal) this.$refs.sectionConfigModal.hide()
            },
            save() {
                if (_.isEmpty(this.section.clientKey)) {
                    this.section.clientKey = this.section.name;
                }
                // format data
                this.section.minInstance = parseInt(this.section.minInstance);
                this.section.maxInstance = parseInt(this.section.maxInstance);

                this.$emit('updateSectionInfo', this.section, this.index);
                this.closeModal();
            },
        },
        created () {
            this.$nextTick(() => {
                let parentInst = this

                while (!$(parentInst.$el).hasClass('form-builder-root')) {
                    parentInst = parentInst.$parent
                }

                this.autonomous = parentInst.autonomous
            })
        },
        mounted() {
            $("[data-toggle='tooltip']").tooltip();
        }
    }
</script>

<style scoped>

</style>
